var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from "prop-types";
import React from "react";
import "./styles.css";
var PromotionNewsLetter = function (props) {
    // @ts-ignore
    var children = props.children, id = props.id, description = props.description, title = props.title, __TYPE = props.__TYPE, remainingProps = __rest(props, ["children", "id", "description", "title", "__TYPE"]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "fr-follow__newsletter" },
            React.createElement("div", null,
                React.createElement("h5", { className: "fr-h5 fr-follow__title" }, title),
                React.createElement("p", { className: "fr-text--sm fr-follow__desc" }, description),
                children))));
};
PromotionNewsLetter.defaultProps = { __TYPE: "PromotionNewsLetter" };
PromotionNewsLetter.propTypes = { __TYPE: PropTypes.string };
export default PromotionNewsLetter;
